import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import EmailField from '@/components/forms/new/formikFormFields/EmailField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const SupportContactEmail = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const handleChange = (e) => {
        updateFormData(FORM_FIELD_PATHS.SUPPORT_CONTACT_EMAIL, e.target.value);
    };

    const hasError =
        !!errors?.supportContactEmail && touched?.supportContactEmail;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Support Contact Email
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={EmailField}
                        id="supportContactEmail"
                        name="supportContactEmail"
                        value={formData?.supportContactEmail || ''}
                        onChange={handleChange}
                        placeholder="Enter support contact email"
                        width="100%"
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the email address for technical support contact"
                        ariaLabel="support-contact-email-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default SupportContactEmail;
